var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHowSvg3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9998 18.9377L29.8065 14.9032C28.8918 14.191 27.7483 13.8376 26.5912 13.9096C25.4342 13.9815 24.3433 14.4738 23.5239 15.2939L23.1172 15.7018",
    stroke: "#4D4E99",
    strokeWidth: 1.99997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M5 12.7037C5 10.7942 5.75857 8.96289 7.10883 7.61267C8.45909 6.26245 10.2904 5.50391 12.2 5.50391",
    stroke: "#4D4E99",
    strokeWidth: 1.99997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.67969 12.8232C8.67969 11.6771 9.13497 10.578 9.94538 9.7676C10.7558 8.95722 11.8549 8.50195 13.001 8.50195",
    stroke: "#4D4E99",
    strokeWidth: 1.99997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62598 16.9414L8.64865 17.9187C8.51484 18.0523 8.40869 18.211 8.33627 18.3857C8.26384 18.5603 8.22656 18.7476 8.22656 18.9367C8.22656 19.1258 8.26384 19.313 8.33627 19.4877C8.40869 19.6623 8.51484 19.821 8.64865 19.9546L21.0153 32.3223C21.149 32.4561 21.3078 32.5623 21.4826 32.6347C21.6574 32.7072 21.8448 32.7444 22.034 32.7444C22.2232 32.7444 22.4105 32.7072 22.5853 32.6347C22.7601 32.5623 22.9189 32.4561 23.0526 32.3223L24.5446 30.809",
    stroke: "#4D4E99",
    strokeWidth: 1.99997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2677 27.1695L30.3863 24.9976C30.5201 24.864 30.6263 24.7053 30.6987 24.5306C30.7711 24.356 30.8084 24.1687 30.8084 23.9796C30.8084 23.7905 30.7711 23.6033 30.6987 23.4286C30.6263 23.254 30.5201 23.0953 30.3863 22.9617L18.0143 10.5941C17.8806 10.4602 17.7218 10.354 17.547 10.2816C17.3722 10.2092 17.1849 10.1719 16.9957 10.1719C16.8064 10.1719 16.6191 10.2092 16.4443 10.2816C16.2695 10.354 16.1107 10.4602 15.977 10.5941L15.3477 11.2247",
    stroke: "#4D4E99",
    strokeWidth: 1.99997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7617 24.8535L28.5177 21.0977",
    stroke: "#4D4E99",
    strokeWidth: 1.99997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1562 30.462L21.7576 27.8594",
    stroke: "#4D4E99",
    strokeWidth: 1.99997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0006 35.4987L28.1433 33.2134C26.9697 32.822 25.9034 32.1629 25.0286 31.2881L22.1793 28.4389C21.7864 28.046 21.5536 27.5211 21.5262 26.9662C21.4988 26.4112 21.6787 25.8659 22.0311 25.4363C22.3834 25.0067 22.8829 24.7234 23.4325 24.6416C23.9821 24.5598 24.5424 24.6853 25.0046 24.9936L29.9593 28.2962",
    stroke: "#4D4E99",
    strokeWidth: 1.99997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.105 22.3433C17.5753 22.42 18.0573 22.3822 18.5099 22.2329C18.9626 22.0837 19.3725 21.8275 19.705 21.486C20.2201 21.1047 20.5677 20.539 20.6751 19.9073C20.7824 19.2755 20.6412 18.6267 20.281 18.0967C19.7705 17.7097 19.1301 17.5351 18.4938 17.6097C17.8575 17.6842 17.2748 18.0021 16.8676 18.4967C16.4598 18.9912 15.8767 19.309 15.2401 19.3835C14.6034 19.4581 13.9626 19.2836 13.4516 18.8967C13.0921 18.3665 12.9512 17.7179 13.0586 17.0864C13.1659 16.4548 13.5131 15.8891 14.0276 15.5075C14.3585 15.1632 14.7678 14.9039 15.2205 14.7519C15.6732 14.5998 16.156 14.5594 16.6276 14.6342M19.7051 21.4849L20.6504 22.4808M13.0823 14.5L14.0277 15.4973",
    stroke: "#4D4E99",
    strokeWidth: 1.99997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowSvg3);
export default __webpack_public_path__ + "static/media/howSVG3.d90296035c46226886c572b98e6818be.svg";
export { ForwardRef as ReactComponent };